import React from 'react';


/**
 * A React Hook for holding toggle state.
 * @param startToggled - whether or not the hook should initialize as toggled. Default: false
 * @returns Array where first item is the toggle state, and the second item is a function that flips the toggle state
 *          when called
 */
export const useToggle = (startToggled: boolean | (() => boolean) = false): [boolean, () => void] => {
  const [isToggled, setIsToggled] = React.useState(startToggled);

  return [isToggled, () => setIsToggled(!isToggled)];
};
